import { UseQueryResult } from 'react-query';
import {
  retrieveAffiliationsById,
  retrieveAvailableAffiliations,
} from '../../../../common/src/legacy/services/apiRouterService';
import { Affiliations, BrokerAffiliations } from '../../../../../types/Broker';
import useQueryFetch from '../../../../common/src/hooks/useQueryFetch';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

export const useAffiliations = (): UseQueryResult<Affiliations> => {
  return useQueryFetch<Affiliations>({
    queryKey: ['affiliations'],
    fetchFn: () => retrieveAvailableAffiliations(),
    options: {
      refetchOnWindowFocus: false,
      enabled: !isSocialLoginUrl,
    },
  });
};

export const useBrokerAffiliations = (): UseQueryResult<BrokerAffiliations> => {
  const { user } = useAuth();
  return useQueryFetch<BrokerAffiliations>({
    queryKey: ['brokerAffiliations', user?.id],
    fetchFn: () => retrieveAffiliationsById(user?.id),
    options: {
      refetchOnWindowFocus: false,
      enabled: !isSocialLoginUrl,
    },
  });
};
